<template> 
    <div class="contact-us d-flex align-items-center mb-4">
          <h2 id="famous-companies " class="section-title"
          >
          تواصل معنا</h2>
          <div class="blue-line"></div>
        </div>

        <b-row > 
        <b-col cols="7" class="d-flex flex-column justify-content-center " >
            <b-row class="my-1">
                <b-col cols="3">
                <label for="input-small">الاسم:</label>
                </b-col>
                <b-col cols="9">
                <b-form-input
                        type="text"
                        class="form-input"
                        placeholder="الاسم "
                    />
                </b-col>
         </b-row>
         <b-row class="my-1">
                <b-col cols="3">
                <label for="input-small">البريد الالكتروني:</label>
                </b-col>
                <b-col cols="9">
                    <b-form-input
            type="text"
            class="form-input"
            placeholder=" البريد الالكتروني"
          />
                </b-col>
         </b-row>
         <b-row class="my-1">
                <b-col cols="3">
                <label for="input-small">رقم التليفون :</label>
                </b-col>
                <b-col cols="9">
                   
          <b-form-input
            type="email"
            class="form-input"
            placeholder="رقم التليفون "
          />
                </b-col>
         </b-row>

         <b-row class="my-1 mt-5">
              <b-col cols="12" class="d-flex justify-content-center align-items-center">
                  <b-button
                    class="login-btn"
                    variant="primary"
                    type="submit"
                  >
              <span> إرسال</span>
            </b-button>
          </b-col>
         </b-row>
          
    
        </b-col>

        <b-col cols="5" >
            <img
                class="contact-img object-cover"
                src="@/assets/img/news/news.jpeg"
                alt="go To Training"

              />
        </b-col>
        </b-row>
 


</template>


<style scoped> 
.contact-img{
height: 300px;
border-radius: 10px;
}

</style>